import { safetyMargins } from '@bedrock-rdk/constants';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const w = SCREEN_WIDTH[screenSize];
  const h = SCREEN_HEIGHT[screenSize];

  return {
    w,
    h,
    color: colors.background[colorMode],
    Grid: {
      // w,
      // h,
      x: safetyMargins.horizontal[screenSize],
    },
  };
};
